// Record selection
function RecordRegionOfOriginChoice(regionName, regionAbbrev, regionImageFileNm) {
    // console.log("Alert:RecordRegionOfOriginChoice: regionName=="+regionName+" regionAbbrev=="+regionAbbrev+" regionImageFileNm=="+regionImageFileNm ) ;
    // console.log("regionName", regionName)
        
    localStorage.setItem("RegionOfOrigin", regionName) ;
    localStorage.setItem("RegionOfOriginDefault", "UserProvided") ;
    localStorage.setItem("RegionOfOriginAbbrev", regionAbbrev) ;
    localStorage.setItem("RegionOfOriginImageFileName", regionImageFileNm) ;

    window.location.assign("https://jimaworks.com/pages/around-when-did-your-first-gen-cross") ;
}

function linkToContact(){
    window.location.assign("https://jimaworks.com/pages/contact-us") 
}

document.addEventListener('DOMContentLoaded', () => {
      


    // Create the map-viewport with scrolling
        const map = document.querySelector('.map-inner');
    
        let isDragging = false;
        let startX, startY;
        let currentX = 0, currentY = 0;
    
        function start(e) {
            isDragging = true;
            map.style.cursor = 'grabbing';
    
            const point = e.touches ? e.touches[0] : e;
            startX = point.clientX - currentX;
            startY = point.clientY - currentY;
        }
    
        const viewport = document.querySelector('.map-viewport');
    
        function move(e) {
            if (!isDragging) return;
    
            const point = e.touches ? e.touches[0] : e;
            let newX = point.clientX - startX;
            let newY = point.clientY - startY;
    
            const maxX = 0;
            const maxY = 0;
            const minX = viewport.offsetWidth - map.offsetWidth;
            const minY = viewport.offsetHeight - map.offsetHeight;
    
            currentX = Math.max(minX, Math.min(maxX, newX));
            currentY = Math.max(minY, Math.min(maxY, newY));
    
            map.style.transform = `translate(${currentX}px, ${currentY}px)`;
        }
    
        function end() {
            isDragging = false;
            map.style.cursor = 'grab';
        }
    
        map.addEventListener('mousedown', start);
        window.addEventListener('mousemove', move);
        window.addEventListener('mouseup', end);
    
        map.addEventListener('touchstart', start);
        window.addEventListener('touchmove', move);
        window.addEventListener('touchend', end);
    // Clone Map tool-tip text into the text column of image text section
        const tipsContainer = document.querySelector('.map-tips');
        const allOrigins = document.querySelectorAll('.map-origin');

        allOrigins.forEach(el => {
            const tooltip = el.querySelector('.tooltip-box');
            let hoverTimer = null;

            el.addEventListener('mouseenter', () => {
                if (!tooltip) return;
                hoverTimer = setTimeout(() => {
                    // remove active from all, then add to current
                    allOrigins.forEach(o => o.classList.remove('active'));
                    el.classList.add('active');
                    tipsContainer.innerHTML = '';
                    tipsContainer.appendChild(tooltip.cloneNode(true));
                }, 175);
            });

            el.addEventListener('mouseleave', () => {
                clearTimeout(hoverTimer);
            });
        });
});


document.addEventListener('DOMContentLoaded', function() {
  var hint = document.getElementById('mapPanHint');
  var viewport = document.querySelector('.map-viewport');

  if (!hint || !viewport) return;

  // Don't show again if the user has already panned before
//   if (localStorage.getItem('mapPanHintDismissed')) {
//     hint.remove();
//     return;
//   }

  function dismissHint() {
    hint.classList.add('pan-hint--hiding');
    // setTimeout(function() {
    //   hint.remove();
    // }, 300);
    localStorage.setItem('mapPanHintDismissed', 'true');

   // viewport.removeEventListener('mousedown', dismissHint);
   // viewport.removeEventListener('touchstart', dismissHint);
  }

  // viewport.addEventListener('mousedown', dismissHint);
  // viewport.addEventListener('touchstart', dismissHint, { passive: true });

  // Fallback: auto-dismiss after 5s even if user never interacts,
  // so it doesn't linger indefinitely for someone just reading the map
//   setTimeout(function() {
//     if (document.body.contains(hint)) {
//       dismissHint();
//     }
//   }, 5000);
});

